import React, { Suspense, lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const PayOut = lazy(() => import('@pages/dashboard/PayOut'));

export const PayOutRoutes: RouteObject = {
  handle: {
    label: 'Payouts',
    key: 'pay-out',
    skipBreadCrumb: true,
  },
  children: [
    {
      path: '/dashboard/pay-out',
      handle: {
        label: 'Payout History',
      },
      element: (
        <Suspense>
          <PayOut />
        </Suspense>
      ),
    },
  ],
};
